/**
 * Map plugins that will be started even without bundle plugin configuration.
 */
export var automagicPlugins = ['Oskari.mapframework.mapmodule.VectorTileLayerPlugin', 'Oskari.mapframework.mapmodule.BingMapsLayerPlugin', 'Oskari.mapframework.bundle.mapmodule.plugin.PinchZoomResetPlugin'];